import { GET_ADDVENDOR_REQUESTED, GET_UPDATEVENDOR_REQUESTED, GET_VENDOR_REQUESTED, GET_VENDORUSER_REQUESTED } from "resources/actionTypes";

export function getVendor(data) {
  return {
    type: GET_VENDOR_REQUESTED,
    payload:data
  };
}

export function postAddVendor(userAddVendor) {
  const data ={
    userAddVendor:userAddVendor,
  }
  return {
    type: GET_ADDVENDOR_REQUESTED,
    payload: data,
  };
}

export function patchUpdateVendor(userUpdateVendor) {
  const data ={
    userUpdateVendor:userUpdateVendor,
  }
  return {
    type: GET_UPDATEVENDOR_REQUESTED,
    payload: data,
  };
}

export function getVendoruser(data) {
  return {
    type: GET_VENDORUSER_REQUESTED,
    payload:data
  };
}
